import * as React from 'react';
import {useState} from 'react';
import {Main} from "../components/Main";
import {Link, Redirect} from "react-router-dom";
import Services from "../utilities/Services";
import {Box} from "../components/sharedComponents/Box";
import axios from 'axios';
import {getCurrentUser} from "../utilities/Utilities";
import value from "*.png";
import {NotificationManager} from "react-notifications";
import {Button, Form, Modal} from "react-bootstrap";


export class Login extends React.Component<any> {

    state = {
        login: '',
        haslo: '',
        logowanie: false,
        showModalBrakAktywacji: false,
        email: '',
        wysylanieMaila: false
    };


    onChangeInput = (key: string, value: string) => {
        this.setState({[key]: value});
    };

    pobierzDaneDoMigracji = (typ: string) => {
        Services.getDaneDoMigracji(typ, this.state.login, this.state.haslo).then((response) => {
            let dane = response.data;

            dane['login'] = this.state.login;
            dane['typMigracji'] = typ;
            dane['haslo'] = this.state.haslo;

            sessionStorage.setItem('migrationData', JSON.stringify(response.data));
            window.location.replace('/register/migracja');
        }).catch((e) => {
            NotificationManager.error('Błąd migracji', 'Błąd');
        })
    }

    onSubmit = (e: React.FormEvent<any>) => {
        e.preventDefault()
        this.setState({logowanie: true});

        Services.Zaloguj(this.state.login, this.state.haslo).then((response) => {

            let token = 'Basic ' + btoa(this.state.login + ':' + this.state.haslo)

            axios.defaults.headers.common.Authorization = token;

            sessionStorage.setItem('isUserLoggedMM',
                JSON.stringify(Object.assign({}, response.data, {token: token}))
            )

            window.location.replace('/konto')
            //this.props.history.push('/konto');
            this.setState({logowanie: false});

        }).catch(error => {
            //alert(error.response.data.message)

            if(error.response.data.message === 'migration/topEditoApi'){
                NotificationManager.info('Wymagana aktualizacja danych', 'Aktualizacja danych');
                this.pobierzDaneDoMigracji('migration/topEditoApi');
            } else if (error.response.data.message === 'migration/editoTop'){
                NotificationManager.info('Wymagana aktualizacja danych', 'Aktualizacja danych');
                this.pobierzDaneDoMigracji('migration/editoTop');
            } else if (error.response.data.message === 'migration/topAndEdito'){
                NotificationManager.info('Wymagana aktualizacja danych', 'Aktualizacja danych');
                this.pobierzDaneDoMigracji('migration/topAndEdito');
            } else {
                if(error.response.data.message.indexOf('Twoje konto nie zostało jeszcze aktywowane') > -1){
                    this.setState({email: this.state.login, showModalBrakAktywacji: true});
                } else {
                    NotificationManager.error(error.response.data.message, 'Błąd logowania', 5000);
                }
            }

            this.setState({logowanie: false});
        })


        // Services.Login(inputValues).then((response)=>{
        //     console.log(response.data)
            //window.location.replace('/konto')
        // })
    }


    handleKeyPress = (e: any) => {
        if (e.key === 'Enter') {
            this.onSubmit(e);
        }
    };

    closeForm = () => {
        this.setState({showModalBrakAktywacji: false});
    }

    wyslijEmailAktywacja = () => {
        this.setState({wysylanieMaila: true});
        Services.wyslijLinkAktywacyjny(this.state.email).then((response) => {
            this.setState({wysylanieMaila: false, showModalBrakAktywacji: false});
            NotificationManager.info('Link aktywacyjny został wysłany na podany adres email', 'Wysłano');
        }).catch((error) => {
            this.setState({wysylanieMaila: false});
            NotificationManager.error(error.response.data.message, 'Błąd wysyłki', 5000);
        })
    }

    render(){

        let {login, haslo, logowanie, showModalBrakAktywacji, email, wysylanieMaila} = this.state;

        return <Main active={'LOGIN'}>
            <Box>
                <h3>Logowanie</h3>
                <p>Zaloguj się, by używać Karty Stałego Klienta. Karta ta służy do gromadzenia upustu na przyszłe
                    zakupy.</p>
                <form onSubmit={this.onSubmit} onKeyPress={this.handleKeyPress}>
                    <section className={'register-form'}>
                        <div className={'row'}>
                            <div className={'col-sm-2'}>
                                <span>Login:</span>
                            </div>
                            <div className={'col-sm-10'}>
                                <input type={'text'} className={'form-control'} value={login}
                                       onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onChangeInput('login', e.target.value.toLowerCase())}
                                       name={'login'}/>
                            </div>
                            <div className={'col-sm-2'}>
                                <span>Hasło:</span>
                            </div>
                            <div className={'col-sm-10'}>
                                <input type={'password'} className={'form-control'} value={haslo}
                                       onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onChangeInput('haslo', e.target.value)}
                                       name={'haslo'}/>
                            </div>
                            <div className={'col-sm-2'}/>
                            <div className={'col-sm-10'}>
                                <Link to={'/lost-password'}><span className={'password-lost'}>Nie pamiętam hasła</span></Link>
                            </div>
                        </div>
                    </section>
                    <div className={'buttons-line'}>
                        <Link to={'/register'}><button className={'btn btn-custom-primary'}>Zarejestruj się</button></Link>
                        <button className={'btn btn-custom-secondary'} disabled={logowanie}>Zaloguj</button>
                    </div>
                </form>
            </Box>

            <Modal show={showModalBrakAktywacji} onHide={this.closeForm}>
                <Modal.Header>
                    <Modal.Title>Konto nieaktywne</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Twoje konto nie zostało jeszcze aktywowane. Sprawdź pocztę e-mail i kliknij w link aktywacyjny.</p>
                    <p>Jeśli e-mail aktywacyjny nie doszedł możesz wysłać go ponownie.</p>
                    {/*<Form.Label>Email:</Form.Label>*/}
                    {/*<Form.Control*/}
                    {/*    type="email"*/}
                    {/*    placeholder="Email..."*/}
                    {/*    autoFocus*/}
                    {/*    value={email}*/}
                    {/*    onChange={(e) => this.setState({email: e.target.value})}*/}
                    {/*/>*/}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.closeForm}>
                        Zamknij
                    </Button>
                    <Button variant="primary" onClick={this.wyslijEmailAktywacja} disabled={wysylanieMaila}>
                        Wyślij e-mail aktywacyjny
                    </Button>
                </Modal.Footer>
            </Modal>
        </Main>
    }

}

export default Login;
